import { render, staticRenderFns } from "./DetailsItemOrange.vue?vue&type=template&id=2a8dbf8c&scoped=true"
import script from "./DetailsItemOrange.vue?vue&type=script&lang=js"
export * from "./DetailsItemOrange.vue?vue&type=script&lang=js"
import style0 from "./DetailsItemOrange.vue?vue&type=style&index=0&id=2a8dbf8c&prod&scoped=true&lang=css"
import style1 from "./DetailsItemOrange.vue?vue&type=style&index=1&id=2a8dbf8c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a8dbf8c",
  null
  
)

export default component.exports